<script setup lang="ts">
import { useI18N } from '../../legacy/lib/use-i18n';
import AskLink from '../../ui/action-plug/ask-link.vue';
import BasePromoBadge from '../../ui/base-promo-badge/base-promo-badge.vue';

type Props = {
  title: string;
  description: string;
  mailSubject: string;
  mailBody: string;
};
const { mailSubject, mailBody } = defineProps<Props>();
const i18n = useI18N();
</script>

<template>
  <div :class="$style.plug">
    <base-promo-badge
      :text="i18n('not-set')"
      icon="lock-main"
      type="alt"
    />
    <h2 :class="$style.title">
      {{ title }}
    </h2>
    <slot name="description">
      <p :class="$style.description">
        {{ description }}
      </p>
    </slot>

    <ask-link
      :mail-subject="mailSubject"
      :mail-body="mailBody"
      color="green"
    />
  </div>
</template>

<style module scoped>
.plug {
  padding: 24px;
  border-radius: 8px;
  background: $whiteColor;
  width: 450px;
}
.title {
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  margin: 16px 0 0;
  &:first-child {
    margin-top: 0;
  }
}
.description {
  margin: 0 0 12px;
  font-size: 16px;
  line-height: 24px;
}
</style>

<i18n lang="json">{}</i18n>
